import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7de6b4db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "state" }
const _hoisted_2 = { class: "statistics" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已浏览", -1))
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已报名", -1))
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已分享", -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已成交", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hi",
  src: "https://b.s.mywsy.cn/media/image/default_header.jpg-sq.90",
  alt: ""
}, null, -1))

import {IBasicVirtual} from "@/app/editor/modules/basic/v1";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityStateBasicStyle',
  props: {
    virtual: {},
    isShowStatistics: { type: Boolean }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_ctx.virtual.view), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_ctx.virtual.sign), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(_ctx.virtual.share), 1),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, _toDisplayString(_ctx.virtual.pay), 1),
        _hoisted_10
      ])
    ]),
    (_ctx.isShowStatistics)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 0,
          style: {"border-top":"1px solid #e4e4e4"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(12), (i) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                span: 4,
                key: i
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})